import React from "react";
import { useGlobalContext } from "../../context";
import QuestionForm from "./QuestionForm";

const ExamForm = ({ updateExams, exam }) => {
  const { apiClient } = useGlobalContext();
  const [loading, setLoading] = React.useState(false);
  const [name, setName] = React.useState("");
  const [calBreNum, setCalBreNum] = React.useState("");
  const [questions, setQuestions] = React.useState([]);
  const [selected, setSelected] = React.useState(0);
  const closeBtn = React.useRef(null);

  function nextQues() {
    if (selected < questions.length - 1) {
      setSelected(selected + 1);
    }
  }
  function prevQues() {
    if (selected > 0) {
      setSelected(selected - 1);
    }
  }
  async function addQuestion() {
    setQuestions([
      ...questions,
      {
        text: "",
        a: "",
        b: "",
        c: "",
        d: "",
        answer: "a",
      },
    ]);
    setSelected(questions.length);
  }
  async function removeQuestion() {
    const items = [...questions];
    items.splice(selected, 1);
    setQuestions(items);
    prevQues();
  }
  async function editQuestion(k, v) {
    const items = [...questions];
    const item = {
      ...items[selected],
      [k]: v,
    };
    items[selected] = item;
    setQuestions(items);
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!name || !calBreNum) {
      alert("Please fill all field!");
      return;
    }
    try {
      setLoading(true);
      let res;
      if (exam) {
        res = await apiClient.put(`/exams/${exam}`, {
          name,
          calBreNum,
          questions,
        });
      } else {
        res = await apiClient.post("/exams", { name, calBreNum, questions });
        setName("");
        setCalBreNum("");
        setQuestions([]);
        setSelected(0);
      }
      updateExams(res.data);
      closeBtn.current.click();
    } catch (error) {
      alert(error);
    } finally {
      setLoading(false);
    }
  }
  async function loadExam(id) {
    try {
      setLoading(true);
      const res = await apiClient.get(`/exams/${id}`);
      const data = res.data;
      if (!data || data.length < 1) {
        alert("Exam not found.");
      } else {
        setName(data.name);
        setCalBreNum(data.calBreNum);
        setQuestions(data.questions);
      }
    } catch (error) {
      alert(error);
    } finally {
      setLoading(false);
    }
  }
  React.useEffect(() => {
    setSelected(0);
    if (exam) {
      loadExam(exam);
    } else {
      setName("");
      setCalBreNum("");
      setQuestions([]);
    }
  }, [exam]);

  return (
    <>
      <div
        className="modal fade"
        id="examFormModal"
        tabIndex="-1"
        aria-labelledby="addModalLabel"
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="addModalLabel">
                {exam ? "Update Exam" : "Create New Exam"}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                ref={closeBtn}
              ></button>
            </div>
            {loading ? (
              <h1 className="text-center display-6 text-muted py-3">
                Loading...
              </h1>
            ) : (
              <form onSubmit={handleSubmit}>
                <div className="modal-body">
                  <div className="row g-2 mb-4">
                    <div className="col-6">
                      <label htmlFor="name-input">
                        <h6 className="m-0">Name</h6>
                      </label>
                      <input
                        type="text"
                        id="name-input"
                        className="form-control form-control-sm"
                        required={true}
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </div>
                    <div className="col-6">
                      <label htmlFor="calBreNum-input">
                        <h6 className="m-0">CalDRE Approval Number</h6>
                      </label>
                      <input
                        type="text"
                        id="calBreNum-input"
                        className="form-control form-control-sm"
                        required={true}
                        value={calBreNum}
                        onChange={(e) => setCalBreNum(e.target.value)}
                      />
                    </div>
                  </div>
                  {questions.length ? (
                    <>
                      <div className="d-flex justify-content-between align-items-center">
                        <h6>
                          Questions ({selected + 1}/{questions.length})
                        </h6>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-danger py-0"
                          onClick={removeQuestion}
                        >
                          Remove this question
                        </button>
                      </div>
                      <QuestionForm
                        question={questions[selected]}
                        editQuestion={editQuestion}
                      />
                      <div className="d-flex mb-3">
                        <button
                          type="button"
                          className="btn btn-sm btn-secondary w-50 me-3"
                          onClick={prevQues}
                          disabled={selected === 0}
                        >
                          Previous
                        </button>
                        <button
                          type="button"
                          className="btn btn-sm btn-secondary w-50"
                          onClick={nextQues}
                          disabled={selected === questions.length - 1}
                        >
                          Next
                        </button>
                      </div>
                    </>
                  ) : (
                    <h6 className="text-center text-muted p-3">
                      No questions added.
                    </h6>
                  )}
                  <button
                    type="button"
                    className="btn btn-sm btn-primary w-100"
                    onClick={addQuestion}
                  >
                    Add Question
                  </button>
                </div>
                <div className="d-flex p-3 justify-content-end">
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-sm btn-success px-4 ms-2"
                  >
                    {exam ? "Update Exam" : "Create Exam"}
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ExamForm;
